import { useLayoutEffect, useState } from 'react';

const CHIP_WIDTH = 120;
const RESERVED_SPACE = 48;

// How many chips (estimated at CHIP_WIDTH each) fit in the container on one line.
const getChipLimit = (container, itemCount) => {
	const { paddingLeft, paddingRight } = window.getComputedStyle(container);
	const horizontalPadding = parseFloat(paddingLeft) + parseFloat(paddingRight);

	const available = container.offsetWidth - horizontalPadding - RESERVED_SPACE;
	const maxVisible = Math.floor(available / CHIP_WIDTH);

	// If every item fits, no overflow chip is rendered at all. Otherwise the
	// overflow chip itself takes up a chip's worth of space, so reserve room
	// for it rather than letting it push the row past the available width.
	const needsOverflowChip = itemCount > maxVisible;
	const limit = needsOverflowChip ? Math.floor((available - CHIP_WIDTH) / CHIP_WIDTH) : maxVisible;

	return Math.max(limit, 1);
};

/**
 * The number of chips to show on one line of the container, recalculated when the item count
 * or the container's size changes (e.g. a resized column or window).
 */
export const useChipFit = (containerRef, itemCount) => {
	const [limitTags, setLimitTags] = useState(1);

	useLayoutEffect(() => {
		const container = containerRef.current;
		if (!container) return;

		setLimitTags(getChipLimit(container, itemCount));

		const observer = new ResizeObserver(() => setLimitTags(getChipLimit(container, itemCount)));
		observer.observe(container);
		return () => observer.disconnect();
	}, [itemCount]);

	return limitTags;
};
